export default {
  username: "Nombre de Usuario",
  clickToUpload: "Haz clic para subir",
  imageFormats: "PNG, JPG hasta 10MB",
  scanning: "Escaneando...",
  or: "o",
  cancel: "Cancelar",
  errors: {
    invalidFileType: "Tipo de archivo inválido",
    pleaseSelectImageFile: "Por favor selecciona un archivo de imagen válido (JPG o PNG)",
    cameraError: "Error de acceso a la cámara",
    pleaseAllowCamera: "Por favor permite el acceso a la cámara para escanear productos",
    scanError: "Error al escanear",
    pleaseTryAgain: "Por favor intenta de nuevo",
    noImageSelected: "No se ha seleccionado ninguna imagen",
    noTextDetected: "No se detectó texto",
    pleaseTryDifferentImage: "Por favor intenta con una imagen diferente",
    visionApiError: "Error al procesar la imagen"
  }
};